// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileDoneOutlinedSvg from "@fishx/icons-svg/es/asn/PFileDoneOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileDoneOutlined = function PFileDoneOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileDoneOutlinedSvg
  }));
};

PFileDoneOutlined.displayName = 'PFileDoneOutlined';
export default React.forwardRef(PFileDoneOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileDoneOutlined.js
// module id = 3386
// module chunks = 0